// extracted by mini-css-extract-plugin
export default {"body":"ManaCurvePanel_body__ESncY"};